<template>
  <div class="sign_in_box">
    <div class="box">
      <img src="/static/index/index17.png" alt="">
      <div>
        <div class="b1">
          <div :class="type==1?'b11':''" @click="type=1">密码登录</div>
          <div :class="type==2?'b11':''" @click="type=2">短信登录</div>
        </div>
        <div class="b2">请填写账号信息</div>
        <div class="b3"><el-input v-model="input" type="number" placeholder="请输入手机号码"></el-input></div>
        <div class="b3" v-if="type==1"><el-input v-model="password" type="password" placeholder="请输入密码"></el-input></div>
        <div class="b3" v-if="type==2"><el-input v-model="code" placeholder="请输入短信验证码"></el-input><div v-if="show" class="b31" @click="getCode">获取验证码</div><div v-else class="b31">{{count}}s后重新获取</div></div>
        <div class="b4">
          <el-button type="primary" @click="submitForm">登录</el-button>
          <!-- <el-checkbox v-model="checked" v-if="type==1">记住密码</el-checkbox> -->
        </div>
        <div class="b6"></div>
        <div class="b5" v-if="type==1" @click="updatePassword">忘记密码？<span>点击重置</span></div>
        <div class="b5" @click="jump('/registered')">没有账号？<span>点击注册</span></div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import Cookie from 'js-cookie'
export default {
  props: [],
  components: {
  },
  data() {

    return {
      checked:false,
      input:'',
      password:'',
      code:'',
      type:1,
      show:true,
      count:"",
      timer:null,
    };
  },
  methods: {
    ...mapActions([]),
    jump(e){
      this.$router.push(e)
    },
    updatePassword(){
      this.$message.error("请进去app或者微信小程序联系客服");
    },
    getCode(){
      if(!/^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/.test(this.input)){
        this.$message.error("请输入正确电话号码");
        return;
      }
      this.$axios
        .post("/do_check_sms",this.$qs.stringify({telephone:this.input}))
        .then((res) => {
          console.log(res);
          if(res.data.errCode==0){
             this.$message({
              message: "发送成功",
              type: "success",
            });
            this.getPhoneCode()
          }
          
        });
    },
    getPhoneCode(){
      let TIME_COUNT = 60;
      if (!this.timer) {
        this.count = TIME_COUNT;
        this.show = false;
        this.timer = setInterval(()=>{
          if (this.count > 0 && this.count <= TIME_COUNT){
            this.count--;
          }else {
            this.show = true;
            clearInterval(this.timer);
            this.timer = null;
          }
        },1000)
      }
    },
    submitForm() {
      let obj
      if(this.type==2){
        if(!/^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/.test(this.input)){
          this.$message.error("请输入正确电话号码");
          return;
        }else if(!this.code){
          this.$message.error("请输入验证码");
          return;
        }
        obj={
          method:2,
          accountJson:JSON.stringify({
            smsCode:this.code,
            telephone:this.input
          })
        }
      }else{
        if(!this.input){
          this.$message.error("请输入电话号码");
          return;
        }else if(!this.password){
          this.$message.error("请输入密码");
          return;
        }
        obj={
          method:3,
          accountJson:JSON.stringify({
            password:this.password,
            telephone:this.input
          })
        }
      }
      
      this.$axios
        .post("/check_login",this.$qs.stringify(obj))
        .then((res) => {
          console.log(res);
          if(res.data.errCode==0){
             this.$message({
              message: "登录成功",
              type: "success",
            });
            window.sessionStorage.setItem('access_token', res.data.data.token)
            Cookie.set('id',res.data.data.aid)
            Cookie.set('name',res.data.data.nickName)
            Cookie.set('level',res.data.data.level)
            this.$router.push('/index')
          }else{
             this.$message.error(res.data.msg);
          }
          
        });
    }
  }
};
</script>
<style lang="scss" scoped>
.sign_in_box{
  width: 100%;
  // height: 100%;
  background: #FFFFFF;
  // overflow-y: auto;
  display: flex;
  flex-direction: column;
  padding-top: 120px;
  .box{
    width: 1200px;
    margin: 0 auto;
    // padding: 0 23px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    &>img{
      width: 639px;
      height: 566px;
    }
    &>div{
      width: 522px;
      .b1{
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 43px;
        div{
          width: 45%;
          text-align: left;
          font-size: 40px;
          font-family: SourceHanSansCN-Medium, SourceHanSansCN;
          font-weight: 500;
          color: #999999;
        }
        .b11{
          font-weight: bold;
          color: #333333;
        }
      }
      .b2{
        font-size: 16px;
        font-family: SourceHanSansCN-Medium, SourceHanSansCN;
        font-weight: 600;
        color: #333333;
        margin-bottom: 26px;
      }
      .b3{
        width: 522px;
        height: 53px;
        border-radius: 4px;
        border: 1px solid #CCCCCC;
        margin-top: 16px;
        display: flex;
        align-items: center;
        justify-content: center;
        position: relative;
        .el-input{
          width: 95%;
          /deep/ .el-input__inner{
          background: transparent;
          border: none;
          
          &::placeholder {
            font-size: 18px;
            font-family: SourceHanSansCN-Medium, SourceHanSansCN;
            font-weight: 500;
            color: #999999;
          }
        }
        }
        .b31{
          font-size: 18px;
          font-family: SourceHanSansCN-Medium, SourceHanSansCN;
          font-weight: 500;
          color: #FF5602;
          position: absolute;
          right: 20px;
          top: 15px;
          z-index: 99;
          cursor: pointer;
        }
        
      }
      .b4{
        margin-top: 40px;
        .el-button{
          padding: 16px 76px;
          background: #198AFA;
          margin-right: 20px;
        }
      }
      .b5{
        font-size: 18px;
        font-family: SourceHanSansCN-Regular, SourceHanSansCN;
        font-weight: 400;
        color: #999999; 
        margin-bottom: 27px;
        cursor: pointer;
        span{
          color: #198AFA;
        }
      }
      .b6{
        width: 510px;
        height: 1px;
        background: #cccccc46;
        margin: 20px auto;
      }
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/pages/Login/index.vue